import { QueryClient, QueryClientProvider, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { ConsoleApiError, SESSION_EXPIRED } from "../lib/api";
import { keys, useMe } from "../lib/queries";
import { LoginPage } from "../features/auth/LoginPage";
import { PageSkeleton, ToastProvider } from "../ui/Feedback";
import { router } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // Auth and validation errors won't fix themselves on retry.
      retry: (count, error) => !(error instanceof ConsoleApiError && error.status < 500) && count < 2,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthGate />
      </ToastProvider>
    </QueryClientProvider>
  );
}

/** Shows the login screen until /auth/me succeeds; drops back to it whenever a session expires. */
function AuthGate() {
  const me = useMe();
  const client = useQueryClient();

  useEffect(() => {
    const expire = () => client.setQueryData(keys.me, null);
    window.addEventListener(SESSION_EXPIRED, expire);
    return () => window.removeEventListener(SESSION_EXPIRED, expire);
  }, [client]);

  if (me.isPending) return <div style={{ padding: 40 }}><PageSkeleton /></div>;
  if (!me.data) return <LoginPage />;
  return <RouterProvider router={router} />;
}
